import React, {
    useMemo,
    useCallback
} from "react";

import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css";

import dayjs from "dayjs";

import clsx from "clsx";

import { motion } from "framer-motion";

import "../styles/attendance-calendar.css";


const STATUS_COLOURS = {

    Present: "#22C55E",

    Absent: "#EF4444",

    Late: "#3B82F6",

    Excused: "#9333EA"

};
const STATUS_ICONS = {

    Present: "✓",

    Absent: "✕",

    Late: "⏰",

    Excused: "E"

};


export default function AttendanceCalendar({

    selectedDate,

    onDateChange,

    calendar = [],

    loading,

    searchResults = []

}) {
    const attendanceMap = useMemo(() => {

        const map = {};

        calendar.forEach(item => {

            const date = dayjs(

                item.attendance_date

            ).format("YYYY-MM-DD");

            if (!map[date]) {

                map[date] = [];

            }

            map[date].push(item);

        });

        return map;

    }, [calendar]);


    const highlightedDates = useMemo(() => {

        const dates = {};

        searchResults.forEach(item => {

            dates[
                dayjs(
                    item.attendance_date
                ).format("YYYY-MM-DD")
            ] = true;

        });

        return dates;

    }, [searchResults]);


    const getEvents = useCallback(

        (date) => {

            const key = dayjs(date)

                .format("YYYY-MM-DD");

            return attendanceMap[key] || [];

        },

        [attendanceMap]

    );


    const getPrimaryStatus = useCallback(

        (events) => {

            if (!events.length) {

                return null;

            }

            if (

                events.some(

                    x => x.status === "Absent"

                )

            ) {

                return "Absent";

            }

            if (

                events.some(

                    x => x.status === "Late"

                )

            ) {

                return "Late";

            }

            if (

                events.some(

                    x => x.status === "Excused"

                )

            ) {

                return "Excused";

            }

            return "Present";

        },

        []

    );

    const formatDate = useCallback(

        (date) =>

            dayjs(date)

                .format("YYYY-MM-DD"),

        []

    );


    const tileContent = useCallback(

        ({ date, view }) => {

            if (view !== "month") {

                return null;

            }

            const events = getEvents(date);

            const key = formatDate(date);

            const highlighted = highlightedDates[key];

            if (!events.length && !highlighted) {

                return null;

            }

            const primaryStatus = getPrimaryStatus(events);

            return (

                <div
                    className={clsx(
                        "attendance-day-wrapper",
                        highlighted && "attendance-search-highlight"
                    )}
                >

                    {
                        events.length > 0 && (

                            <div
                                className="attendance-status-circle"
                                style={{
                                    background:
                                        STATUS_COLOURS[
                                        primaryStatus
                                        ]
                                }}
                            >

                                {
                                    STATUS_ICONS[
                                    primaryStatus
                                    ]
                                }

                            </div>

                        )
                    }

                    {
                        events.length > 1 && (

                            <div
                                className="attendance-count"
                            >

                                {events.length}

                            </div>

                        )
                    }

                </div>

            );

        },

        [

            getEvents,

            highlightedDates,

            getPrimaryStatus,

            formatDate

        ]

    );


    const tileClassName = useCallback(

        ({ date, view }) => {

            if (view !== "month") {

                return "";

            }

            const events = getEvents(date);

            if (!events.length) {

                return "";
            }

            const status = getPrimaryStatus(events);

            return clsx(

                "attendance-day",

                {

                    present:

                        status === "Present",

                    absent:

                        status === "Absent",

                    late:

                        status === "Late",

                    excused:

                        status === "Excused"

                }

            );

        },

        [

            getEvents,

            getPrimaryStatus

        ]

    );


    const tileDisabled = useCallback(

        ({ date }) => {

            return dayjs(date)

                .isAfter(

                    dayjs(),

                    "day"

                );

        },

        []

    );

    const onClickDay = useCallback(

        (date) => {

            onDateChange(date);

        },

        [

            onDateChange

        ]

    );

    const tileClassToday = useCallback(

        ({ date }) => {

            if (

                dayjs(date).isSame(

                    dayjs(),

                    "day"

                )

            ) {

                return "attendance-today";

            }

            return "";

        },

        []

    );

    const getTileClass = useCallback(

        (props) => {

            return clsx(

                tileClassName(props),

                tileClassToday(props)

            );

        },

        [

            tileClassName,

            tileClassToday

        ]

    );


    const animation = {

        initial: {

            opacity: 0,

            y: 25

        },

        animate: {

            opacity: 1,

            y: 0

        },

        transition: {

            duration: .45

        }

    };





    if (loading) {

        return (

            <div className="attendance-calendar-loading">

                Loading Calendar...

            </div>

        );

    }
    return (

        <motion.div

            className="attendance-calendar-wrapper"

            initial={{

                opacity: 0,

                y: 30

            }}

            animate={{

                opacity: 1,

                y: 0

            }}

            transition={{

                duration: .45

            }}

        >


            <div className="attendance-calendar-card">

                <Calendar

                    value={selectedDate}

                    onChange={onClickDay}

                    tileContent={tileContent}

                    tileClassName={getTileClass}

                    tileDisabled={tileDisabled}

                    showNeighboringMonth={false}

                    prev2Label={null}

                    next2Label={null}

                    calendarType="gregory"

                    minDetail="month"

                    maxDetail="month"

                    navigationLabel={({ date }) => (

                        <div className="attendance-navigation-title">

                            {dayjs(date).format("MMMM YYYY")}

                        </div>

                    )}

                />



                <motion.div

                    className="attendance-selected-date"

                    initial={{ opacity: 0 }}

                    animate={{ opacity: 1 }}

                >

                    <div>

                       {/*  <h3>

                            Selected Date

                        </h3>

                        <p>

                            {dayjs(selectedDate).format("dddd, DD MMMM YYYY")}

                        </p> */}

                    </div>

                    <div  style={{  display:"none"}}>

                        {

                            getEvents(selectedDate).length > 0

                                ?

                                <span className="attendance-session-count">

                                    {

                                        getEvents(selectedDate).length

                                    }

                                    {" "}

                                    Session(s)

                                </span>

                                :

                                <span className="attendance-no-session">

                                    No Attendance

                                </span>

                        }


                        {

                            getEvents(selectedDate).length > 0 && (

                                <motion.div

                                    className="attendance-day-summary"

                                    initial={{

                                        opacity: 0,

                                        y: 20

                                    }}

                                    animate={{

                                        opacity: 1,

                                        y: 0

                                    }}

                                >

                                    {

                                        getEvents(selectedDate).map(

                                            event => (

                                                <div

                                                    key={event.id}

                                                    className="attendance-summary-item"

                                                >

                                                    <div

                                                        className="attendance-summary-colour"

                                                        style={{

                                                            background:

                                                                STATUS_COLOURS[

                                                                event.status

                                                                ]

                                                        }}

                                                    />

                                                    <div className="attendance-summary-content">

                                                        <h4>

                                                            {event.title}

                                                        </h4>

                                                        <p>

                                                            {

                                                                event.status

                                                            }

                                                        </p>

                                                    </div>

                                                </div>

                                            )

                                        )

                                    }

                                </motion.div>

                            )

                        }


                        {

                            getEvents(selectedDate).length === 0 && (

                                <motion.div

                                    className="attendance-empty"

                                    initial={{

                                        opacity: 0

                                    }}

                                    animate={{

                                        opacity: 1

                                    }}

                                    style={{ display:"none"}}

                                >

                                    <div className="attendance-empty-icon">

                                        📅

                                    </div>

                                    <h3>

                                     No Attendance Recorded

                                    </h3>

                                    <p>

                                        There are no attendance records for this day.

                                    </p>

                                </motion.div>

                            )

                        }

                    </div>

                </motion.div>

            </div>





        </motion.div>


    )
}
